import React from 'react';
import block from 'bem-cn';

import SVG from 'components/SVG';
import arrowSVG from 'features/reports/img/arrow-sort.svg';
import ReportChart from './ReportChart';

import './Schedule.scss';

const b = block('general-schedule');

const Schedule = ({ scheduleRef, title, isOpen, onToggle, series, withDiff, currency, isMobile, children }) => (
  <section ref={scheduleRef} className={b({ open: isOpen, isMobile })}>
    <button type="button" className={b('header')} onClick={() => onToggle(!isOpen)} aria-expanded={isOpen}>
      <span>{title}</span>
      <SVG className={b('arrow-icon')} svgProps={{ svg: arrowSVG }} />
    </button>
    {isOpen && (
      <div className={b('content')}>
        {children}
        <ReportChart series={series} withDiff={withDiff} currency={currency} isMobile={isMobile} />
      </div>
    )}
  </section>
);

export default Schedule;
